<template>
    <div class="tabs-bar td-card border mt-1">
        <div class="td-tabs secondary">
            <span v-if="hoursType == HoursOfOperationType.SelectHours" :class="[tab == HoursTab.Hours ? 'active' : '', 'td-tab']" @click.prevent="updateNavigation(HoursTab.Hours)">Hours</span>
            <span :class="[tab == HoursTab.Exceptions ? 'active' : '', 'td-tab']" @click.prevent="updateNavigation(HoursTab.Exceptions)">Exceptions</span>
            <span :class="[tab == HoursTab.HolidayHours ? 'active' : '', 'td-tab']" @click.prevent="updateNavigation(HoursTab.HolidayHours)">Holiday Hours</span>
        </div>
        <div class="buttons" v-if="tab == HoursTab.Exceptions">
            <button title="Add Hours Exception" class="td-btn primary icon-left hide-mobile slim" @click.prevent="updateNavigation(tab, true)"><icon name="faPlus" type="solid"></icon> Add Hours Exception</button>
            <button title="Add Hours Exception" class="td-btn primary icon-only show-mobile" @click.prevent="updateNavigation(tab, true)"><icon name="faPlus" type="solid"></icon></button>
        </div>
        <div class="buttons hide-mobile" v-if="tab == HoursTab.Hours && timezone">
            <span class="td-badge dark"><icon type="solid" name="faClock" aria-hidden="true"></icon>{{ timezone }}</span>
        </div>

    </div>
    
</template>
<script>
    import script from './HoursTableNavigation';
    export default script;</script>
<style lang="less">
    @import "./HoursTableNavigation";
</style>